import script from "./AssetHitmap.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetHitmap.vue?vue&type=script&setup=true&lang=js"

import "./AssetHitmap.vue?vue&type=style&index=0&id=65807086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65807086"]])

export default __exports__